import { Route, Routes } from "react-router-dom"
import { HashLink } from 'react-router-hash-link';
import {Home} from "./pages/Home"
import {Reel} from "./pages/Reel"
import {About} from "./pages/About"
import "video-react/dist/video-react.css"; // import css
import { useState, useEffect } from 'react';
import './styles.css'



function App() {

    const [currentLocation, setCurrentLocation] = useState('home');

    useEffect(() => {
        const path = window.location.hash.slice(2);
        setCurrentLocation(path);
    }, []);


    useEffect(() => {
        const handleScroll = () => {
            const sections = ['home', 'reel', 'about'];
            const scrollPosition = window.scrollY + 100;
            sections.forEach(section => {
                const element = document.getElementById(section);
                if (element) {
                    const elementPosition = element.offsetTop;
                    if (scrollPosition >= elementPosition) {
                        setCurrentLocation(section);
                    }
                }
            });
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [currentLocation]);
    
    return (
<>
<nav>
            <ul>
                <HashLink smooth className={`menu-left ${currentLocation === 'home' ? 'active' : ''}`} to="/#" onClick={() => setCurrentLocation('home')}>Shem Shortall</HashLink>
                <ul class="menu-right">
                <li><HashLink smooth className={`menu ${currentLocation === 'reel' ? 'active' : ''}`} to="/#reel" onClick={() => setCurrentLocation('reel')}>Reel</HashLink></li>
                <li><HashLink smooth className={`menu ${currentLocation === 'about' ? 'active' : ''}`} to="/#about" onClick={() => setCurrentLocation('about')}>About</HashLink></li>
                </ul>
            </ul>
        </nav>

        <Routes>
            <Route path="/"  id="home" />
            <Route path="/About" component={About} id="about" />
            <Route path="/Reel" component={Reel} id="reel" />
        </Routes>

        {/* <div id="home"> */}
        <section id="home">
        <Home id="/"/>
        </section>
        {/* </div> */}
        <Reel id="reel"/>
        <About id="about" />

</>
)

}

export default App